import type { ReactNode } from 'react';
import { Logo } from './icons';

/** House drawing of the login hero (design/Login): roof, four flats, one vacant (dashed). */
function HeroHouse() {
  return (
    <svg className="hero-art" viewBox="0 0 420 200" aria-hidden focusable="false">
      <polygon className="roof" points="40,70 210,10 380,70" strokeWidth="2" strokeLinejoin="round" />
      <rect className="body" x="56" y="70" width="308" height="128" strokeWidth="2" />
      <rect className="flat" x="76" y="86" width="126" height="44" rx="8" />
      <rect className="flat" x="218" y="86" width="126" height="44" rx="8" />
      <rect className="flat" x="76" y="142" width="126" height="44" rx="8" />
      <rect className="flat empty" x="218" y="142" width="126" height="44" rx="8" strokeWidth="1.5" strokeDasharray="5 4" />
    </svg>
  );
}

/** Split auth layout (design/Login.dc.html): petrol hero with claim left, form column right. */
export function AuthSplit({ title, text, brand, children, footer }: { title: ReactNode; text?: ReactNode; brand: ReactNode; children: ReactNode; footer?: ReactNode }) {
  return (
    <div className="auth-split">
      <section className="auth-hero">
        <span className="brand"><Logo size={30} />{brand}</span>
        <div className="hero-copy">
          <h1>{title}</h1>
          {text && <p>{text}</p>}
        </div>
        <HeroHouse />
      </section>
      <main className="auth-main" id="main">
        {children}
        {footer && <div className="auth-foot">{footer}</div>}
      </main>
    </div>
  );
}
